<div class="d-flex flex-column justify-content-center align-item-center col-md-6 h-100 w-100">
    <div class="w-50 align-self-center">
        <h1>404</h1>
        <h2>UH OH! You're lost.</h2>
        <p>The page you are looking for does not exist, click the button below
            to go back to the Login page.
        </p>
        <button mat-button class="btn">
            <a class="btn-link" [routerLink]="isLoggedIn ? '/' : '/login'">{{isLoggedIn ? 'Home' : 'Login'}}</a>
        </button>
    </div>
</div>